import { useMutation } from '@apollo/client';
import { FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import invariant from 'tiny-invariant';
import { graphql } from '~/apollo/generated/v4';
import { Button } from '~/components/ui/button';
import { HookFormErrors } from '~/components/ui/forms/HookFormErrors';
import { PaleoMapFormFields } from '~/components/upload/paleomap/paleomap-form-fields';
import { uploadPaleoMapUpdateRoute } from '~/paths';
import { useZodForm } from '~/utils/forms';
import { initialPaleoMap, paleoMapSchema } from '~/utils/modules/paleomap-v4';

const CREATE_PALEO_MAP = graphql(`
  mutation CreatePaleoMap($input: PaleoMapCreateInput!) {
    paleoMapCreate(input: $input) {
      result {
        id
      }
    }
  }
`);

export function CreatePaleoMapForm() {
  const [createPaleoMap, { loading, error }] = useMutation(CREATE_PALEO_MAP);
  const navigate = useNavigate();

  const form = useZodForm({
    schema: paleoMapSchema,
    values: initialPaleoMap(),
  });

  const handleSubmit = form.handleSubmit(async values => {
    try {
      const res = await createPaleoMap({ variables: { input: values } });
      const createdId = res.data?.paleoMapCreate?.result?.id;
      invariant(createdId, 'Error parsing create response');
      toast.success('Palaeomap created successfully.');
      navigate(uploadPaleoMapUpdateRoute(parseInt(createdId)));
    } catch (err) {
      console.log('Error creating paleomap', err);
      toast.error('There was a problem creating the palaeomap');
    }
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <PaleoMapFormFields />

        <HookFormErrors graphQLError={error} />

        <div className="text-center">
          <Button type="submit" color="primary" loading={loading}>
            Save
          </Button>
        </div>
      </form>
    </FormProvider>
  );
}
